export function isSmallScreen () {
	return (window.document.body.clientWidth < 600);
}



// WEBPACK FOOTER //
// ./src/core/utils/index.js